import useLogEvent from 'amplitude/useLogEvent'
import { snakeCase } from 'lodash'
import useSendDataToGTM from './useSendDataToGTM'

/**
 * Returns a function to log event to both the Data Layer and Amplitude
 * The event name format should be "Name Of The Event". This name
 * will be sent to Amplitude as it is, and will be transformed to
 * the snake case version ("name_of_the_event") to be sent to GTM.
 * @returns function to log events, which receives the event name and the payload
 */
const useLogEventToAll = () => {
  const logEvent = useLogEvent()
  const sendDataToGTM = useSendDataToGTM()

  const log = (eventName, payload) => {
    const dataLayerEventName = snakeCase(eventName)

    logEvent(eventName, payload)
    sendDataToGTM(dataLayerEventName, payload)
  }

  return log
}

export default useLogEventToAll
